import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import Loader from '../../../common/loader';
import FD from '../../RestAPI/fetchData';
import AppRoutes from '../../config/AppRoutes';
import App_data from '../../config/App_data';
import CaseCard from './Layout/CaseCard';
import Heading from './Layout/Heading';
import { messages } from '../../../common/messages';
export class Chapters extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      idname: '',
      chapters: [],
      displayLoader: true,
    };
  }
  componentDidMount() {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    this.getChapter(data);
  }
  getChapter = async data => {
    const getChapters = await FD.callAPI(
      `${App_data.backend_api}/cfa3EssayQuestions/getChapterWithCount`,
      data,
    );
    const { success, chapters } = getChapters;
    if (success) {
      this.setState({ ValidToken: true, chapters });
    } else {
      this.setState({
        ValidToken: false,
        chapters: [
          {
            chapter_no: '',
            chapter_name: 'No data found',
            cfa3_essay_case: {
              free_cases: 0,
              premium_cases: 0,
            },
          },
        ],
      });
    }
    this.setState({
      displayLoader: false,
    });
  };

  goToLastAnsweredQuestion = async () => {
    const { idname, token } = this.state;
    const data = { idname, token };
    const getLastAnsweredAnswer = await FD.callAPI(
      `${App_data.backend_api}/cfa3EssayQuestions/getLastAnsweredQuestion`,
      data,
    );
    if (getLastAnsweredAnswer.success) {
      const {
        // user_id,
        // questionId,
        index,
        casesId,
        casesIndex,
        chapterId,
        chapterName,
      } = getLastAnsweredAnswer;
      this.context.router.push({
        pathname: AppRoutes.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', casesId)
          .replace(':chapterName', chapterName)
          .replace(':chapterID', chapterId)
          .replace(':questionIndex', index === -1 ? 0 : index)
          .replace(':caseIndex', casesIndex),
      });
    }
  };
  render() {
    const { chapters, displayLoader } = this.state;
    return (
      <div className='animated fadeIn'>
        {/* ========= Heading ===================== */}
        <Heading headerText='Essay Question'>
          <button
            className='btn btn-primary pointer_class'
            onClick={() => {
              this.goToLastAnsweredQuestion();
            }}
          >
            {messages.GO_TO_MY_LAST_QUESTION_ANSWERED}
          </button>
        </Heading>
        {displayLoader ? (
          <Loader />
        ) : (
          <Row>
            <Col sm='12' md='12' className='seperator-block-wrap'>
              <div className='card'>
                <div className='card-block'>
                  <Row className={chapters.length === 1 ? 'justify-content-center' : ''}>
                    {chapters.map((chapter, index) => (
                      <CaseCard
                        key={index}
                        {...chapter}
                        index={index}
                        router={this.context.router}
                      />
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

export default Chapters;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Chapters.jsx